import { post } from 'aws-amplify/api';
import { PartnerApplication, PartnerApplicationSchema } from '../models/partnerApplication.model';
import { CreateApplicationRequest } from '../models/application.model';
import { trimStrings } from '../utils/trim.util';

export class PartnerValidationError extends Error {
  constructor(message: string, public errors: string[]) {
    super(message);
    this.name = 'PartnerValidationError';
  }
}

const mapToRequest = (app: CreateApplicationRequest): PartnerApplication => {
  const result = PartnerApplicationSchema.safeParse(app);
  if (result.success) return result.data;
  const messages = result.error.issues.map((issue) => `${String(issue.path[0])}: ${issue.message}`);
  throw new PartnerValidationError('Validation error', messages);
};

export const createPartnerApplication = async (app: CreateApplicationRequest): Promise<void> => {
  const body = mapToRequest(trimStrings(app));
  await post({
    apiName: 'applications',
    path: '/partner-applications',
    options: { body: body as any },
  }).response;
};
